import type { Resource } from "i18next";
import deTranslation from "./translations/de.json";
import enTranslation from "./translations/en.json";

/**
 * App-owned locale bags for web. Built here so consumers can mount
 * translations without importing the browser storage bootstrap in `i18n.ts`.
 */
export const resources = {
  de: {
    translation: deTranslation,
  },
  en: {
    translation: enTranslation,
  },
} as const satisfies Resource;
